module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.order !== undefined) ? _c('section', [(_vm.order) ? _c('div', [(_vm.order.prcode == 0) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        Platba ve výši " + _vm._s(_vm.prachy_bez_00(_vm.order.amount)) + " Kč úspěšně dokončena, děkujeme vám.\n      ")]) : _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("Platba ve výši " + _vm._s(_vm.prachy_bez_00(_vm.order.amount)) + " Kč nebyla dokončena.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.prcodeText()))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("PRCODE=" + _vm._s(_vm.order.prcode))])]), _vm._v(" "), (_vm.order.srcode) ? _c('p', [_vm._v("\n          Důvod: "), _c('b', [_vm._v(_vm._s(_vm.srcodeText1()))]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.srcodeText2()))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("SRCODE=" + _vm._s(_vm.order.srcode))])]) : _vm._e(), _vm._v(" "), (_vm.order.amount > 0) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.createOrderPending
    },
    on: {
      "click": function($event) {
        _vm.tryAgain()
      }
    }
  }, [_vm._v("zkusit znovu")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "disabled": _vm.createOrderPending
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/account')
      }
    }
  }, [_vm._v("zrušit")])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f21d2f78","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentFinished.vue
// module id = 331
// module chunks = 1 2